import * as React from "react";

import { initAgentControlWindowApi } from "@app/agent-control/windowApi";
import { App } from "@app/App";
import {
  initializeAnalytics,
  initializeErrorTracking,
  initializePerformanceMonitoring,
} from "@v2/features/infra/analytics/init";
import { installVitePreloadErrorReload } from "replo-utils/lib/chunkLoadError";

// Import stylesheets
import "./index.scss";
import "./tailwind.css";

import { createRoot } from "react-dom/client";

installVitePreloadErrorReload();
initializeErrorTracking();
initializeAnalytics();
initializePerformanceMonitoring();
initAgentControlWindowApi();

// Legacy cast - may or may not be necessary
// eslint-disable-next-line replo/no-as-cast
const root = createRoot(document.querySelector("#root") as HTMLElement);
root.render(<App />);
